import { siteCulture } from 'settings/vistaprintContext';
import BundleUtil from 'utils/BundleUtil.js';
import qs from 'qs';

const host = "https://scheduler.dsp.dst.vpsvc.com/";
const tenant = BundleUtil.getTenant();


export default class SchedulingService {
    static async callSchedulerService(endpoint, data) {
        let queryParam = qs.stringify(data);

        const uri = `${host}${endpoint}?${queryParam}`;
        const response = await fetch(uri, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`${response.status} - ${response.statusText}`);
        }

        return await response.json();
    }

    /**
    * Perform a GET request to the Scheduler Service to get available DesignLive dates
    * @param string timezone
    * @param int calendarId
    */
    async getAvailableDates(timezone, calendarId) {
        const endpoint = 'v1/scheduler/availability/dates';

        const today = new Date();
        const month = `${today.getFullYear()}-${today.getMonth() + 1}`;
        let nextMonth = `${today.getFullYear()}-${today.getMonth() + 2}`;
        if (today.getMonth() === 11) { // If it's December, get Jan of next year
            nextMonth = `${today.getFullYear() + 1}-1`;
        }

        const thisMonthData = {
            month: month,
            timezone: timezone,
            locale: siteCulture,
            calendarId: calendarId,
            tenant: tenant
        }

        const nextMonthData = {
            month: nextMonth,
            timezone: timezone,
            locale: siteCulture,
            calendarId: calendarId,
            tenant: tenant
        }

        // Get this months availability and next months availability concurrently
        const getThisMonthsAvailability = SchedulingService.callSchedulerService(endpoint, thisMonthData);
        const getNextMonthsAvailability = SchedulingService.callSchedulerService(endpoint, nextMonthData);
        const [thisMonthsAvailability, nextMonthsAvailability] = await Promise.all([getThisMonthsAvailability, getNextMonthsAvailability]);

        return thisMonthsAvailability.concat(nextMonthsAvailability);
    }

    /**
    * Perform a GET request to the Scheduler Service to get available DesignLive sessions for a date
    * @param string date
    * @param string timezone
    * @param int calendarId
    */
    async getAvailableTimes(date, timezone, calendarId) {
        if(!date || !timezone) {
            return [];
        }
        
        const endpoint = 'v1/scheduler/availability/times';
        const data = {
            timezone: timezone,
            date: date,
            locale: siteCulture,
            calendarId: calendarId,
            tenant: tenant
        };

        return await SchedulingService.callSchedulerService(endpoint, data);
    }
}



// WEBPACK FOOTER //
// ./src/services/SchedulingService.js